import './ImpactoReal.css';
import impactoImg from '../../assets/img/img_28.jpeg';

const STATS = [
  { num: '10+', label: 'Anos dedicados a fazer a diferença' },
  { num: '🐾',  label: 'Resgatando' },
  { num: '💜',  label: 'Formando famílias com carinho' },
  { num: '∞',   label: 'Amor pelos animais' },
];

export default function ImpactoReal() {
  return (
    <section id="impacto" className="impacto">
      <div className="impacto__grid">
        <div className="impacto__img">
          <img
            src={impactoImg}
            alt="Animais resgatados pela ONG Amanimal"
          />
        </div>

        <div className="impacto__content">
          <span className="section-tag impacto__tag">Nossa História</span>
          <h2 className="section-title impacto__title">
            Transformando compaixão<br />em ação
          </h2>
          <p className="impacto__text">
            Criada em 2015, a Amanimal surgiu com o propósito de cuidar de animais de rua e
            abandonados que necessitam de atenção e cuidados médicos contínuos. Desde então,
            dedicamos nosso tempo, oferecendo resgate, acolhimento e tratamento a animais em
            situação de vulnerabilidade.
          </p>
          <p className="impacto__text">
            Atualmente, somos responsáveis pelo cuidado de mais de 250 gatos, além de cães e
            coelhos, garantindo alimentação, acompanhamento veterinário e muito carinho. Com o
            apoio de voluntários, seguimos trabalhando para oferecer dignidade, bem-estar e uma
            nova chance de vida a cada animal que passa por nossas mãos.
          </p>
          <div className="impacto__stats">
            {STATS.map((s) => (
              <div key={s.label} className="impacto__stat">
                <div className="impacto__stat-icon">{s.num}</div>
                <div className="impacto__stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
